/* eslint-disable import/no-cycle */
import PropTypes from 'prop-types';
import { Card } from 'semantic-ui-react';
import { generateGroups, generateWorkshopStatus } from '../../../utils/groupUtils';
import '../WorkshopList.scss';
import { HorizontalLists } from './variants/HorizontalList';
import TabList from './variants/TabList';
import { VerticalLists } from './variants/VerticalList';
import { WorkshopItems } from './WorkshopItems';

function getVariant(groupByConfig) {
  const { isVertical, variant } = groupByConfig;
  if (isVertical) return 'vertical';
  if (variant) return variant;
  return 'horizontal';
}

const listComponents = {
  vertical: VerticalLists,
  horizontal: HorizontalLists,
  tabs: TabList,
};

export function filterOptionsIfNeeded(groupByConfig, filters) {
  if (!filters) return groupByConfig;
  const { field, options } = groupByConfig;
  if (filters && filters[field] && options) {
    // Filter groups as well...
    return { ...groupByConfig, options: options.filter((opt) => opt.value === filters[field]) };
  }
  return groupByConfig;
}

export const filterRegistered = (workshops, registrations, showOnlyRegistered) => {
  if (!showOnlyRegistered) {
    return workshops;
  }

  return workshops.filter((w) => (w.sessions || [w]).some((s) => !!registrations[s._id]));
};

const WorkshopList = ({
  centered,
  filteredWorkshopIds,
  filters,
  groupBy: groupByConfig,
  itemProps,
  template: inputTemplate,
  workshopList,
}) => {
  const workshops = generateWorkshopStatus(workshopList);
  const template = {
    ...(inputTemplate || {}),
    variant: inputTemplate?.type || inputTemplate?.variant || 'card',
  };
  if (groupByConfig) {
    const variant = getVariant(groupByConfig);
    const groups = generateGroups(workshops, filterOptionsIfNeeded(groupByConfig, filters));
    const ListComponent = listComponents[variant] || HorizontalLists;
    const { iconConfig } = groupByConfig || {};
    return (
      <div className="items--group workshops--group">
        <ListComponent
          centered={centered}
          groupByConfig={groupByConfig}
          groups={groups}
          filteredWorkshopIds={filteredWorkshopIds}
          template={template}
          iconConfig={iconConfig}
          itemProps={itemProps}
        />
      </div>
    );
  }

  return (
    <Card.Group className="workshops--container" itemsPerRow={3} centered={centered}>
      <WorkshopItems
        workshops={workshops}
        filteredWorkshopIds={filteredWorkshopIds}
        template={template}
        itemProps={itemProps}
      />
    </Card.Group>
  );
};

WorkshopList.defaultProps = {
  centered: undefined,
  filters: undefined,
  filteredWorkshopIds: undefined,
  groupBy: undefined,
  itemProps: {},
  template: { variant: 'card' },
};

WorkshopList.propTypes = {
  workshopList: PropTypes.array.isRequired,
  centered: PropTypes.bool,
  filteredWorkshopIds: PropTypes.arrayOf(PropTypes.string),
  filters: PropTypes.object,
  groupBy: PropTypes.shape({
    field: PropTypes.string.isRequired,
    type: PropTypes.string,
  }),
  itemProps: PropTypes.object,
  template: PropTypes.shape({ variant: PropTypes.string, minHeight: PropTypes.number }),
};

export default WorkshopList;
